import React from 'react';
import { IconProps } from '../IconProps';
const SvgBullhorn = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 25 24" fill="none" {...props}>
    <g clipPath="url(#Bullhorn_svg__clip0_539_2340)">
      <path
        d="M12.24 14.34l1.31 6.195a1.333 1.333 0 01-1.03 1.58l-1.304.276a1.333 1.333 0 01-1.58-1.03L8.167 14.34"
        stroke={primaryColor}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.08 7.888a.666.666 0 00-.246.518v3.198a.666.666 0 00.803.652c1.096-.23 1.863-1.157 1.863-2.252 0-1.094-.767-2.021-1.863-2.252a.667.667 0 00-.557.135v.001z"
        fill={primaryColor}
      />
      <path
        d="M19.5 17.672s-2.582-3.333-5.666-3.333H7.167a4.333 4.333 0 110-8.667h6.667c3.082 0 5.666-3.333 5.666-3.333v15.333zM8.167 5.672v8.667"
        stroke={primaryColor}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="Bullhorn_svg__clip0_539_2340">
        <path
          fill={primaryColor}
          transform="translate(.5 .006)"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBullhorn;
